import { makeStyles } from "@material-ui/core/styles";
import React, { useState, useEffect } from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import moment from "moment/moment";

import { isWeekday } from "../shared-resources/utils";

const useStyles = makeStyles((theme) => ({}));

const CustomDatePicker = ({
  dateValue,
  setDateValue,
  dateFormat,
  classVal = "datePicker",
  itemWidth = "100%",
  minDate = null,
  maxDate = null,
  disabled = false,
  disablePasts = false,
}) => {
  const classes = useStyles();
  const [value, setValue] = useState(null);

  useEffect(() => {
    setValue(dateValue);
  }, [dateValue]);

  const onDateChange = (date, datestring) => {
    setValue(date);
    setDateValue(date);
  };

  function disabledDate(current) {
    // Can not select sundays and predfined days
    return (
      (disablePasts && moment().add(-1, "days") >= current) ||
      (minDate && dayjs(minDate, "YYYY-MM-DD") > current) ||
      (maxDate && dayjs(maxDate, "YYYY-MM-DD") < current)
    );
  }

  return (
    <div>
      <DatePicker
        disabledDate={disabledDate}
        format={dateFormat.toUpperCase()}
        className={classVal}
        value={value && value !== "" ? dayjs(value) : null}
        onChange={(date, datestring) => onDateChange(date, datestring)}
        style={{ width: itemWidth }}
        disabled={disabled}
      />
    </div>
  );
};

export default CustomDatePicker;
